import { useContext } from 'react';
import { QueryClientContext } from '@tanstack/react-query';
import { AiAgentStar } from '@ezhire/ui';
import {
  useIsAiAgent,
  useIsAiZiwoAgent,
  useIsAiNativeAgent,
  type AiAgentProfilesOptions,
} from '../hooks/use-ai-agent-profiles';

/** Standalone previews have no query provider: their classification is unavailable. */
export function ProfileAiBadge({
  profileId,
  orgId,
  options,
}: {
  profileId?: string | null;
  orgId: string | null;
  options?: AiAgentProfilesOptions;
}) {
  const client = useContext(QueryClientContext);
  return client && profileId ? (
    <ClassifiedBadge profileId={profileId} orgId={orgId} options={options} />
  ) : null;
}

function ClassifiedBadge({
  profileId,
  orgId,
  options,
}: {
  profileId: string;
  orgId: string | null;
  options?: AiAgentProfilesOptions;
}) {
  const isAi = useIsAiAgent(orgId, options);
  return (
    <span className="inline-flex w-6 shrink-0 items-center align-middle">
      {isAi(profileId) === true ? <AiAgentStar /> : null}
    </span>
  );
}

export function ZiwoAiBadge({
  agentId,
  orgId,
  options,
}: {
  agentId?: string | null;
  orgId: string | null;
  options?: AiAgentProfilesOptions;
}) {
  const client = useContext(QueryClientContext);
  return client && agentId ? (
    <ClassifiedZiwoBadge agentId={agentId} orgId={orgId} options={options} />
  ) : null;
}
function ClassifiedZiwoBadge({
  agentId,
  orgId,
  options,
}: {
  agentId: string;
  orgId: string | null;
  options?: AiAgentProfilesOptions;
}) {
  const isAi = useIsAiZiwoAgent(orgId, options);
  return (
    <span className="inline-flex w-6 shrink-0 items-center align-middle">
      {isAi(agentId) === true ? <AiAgentStar /> : null}
    </span>
  );
}

export function NativeAiBadge({
  agentId,
  orgId,
  options,
}: {
  agentId?: string | null;
  orgId: string | null;
  options?: AiAgentProfilesOptions;
}) {
  const client = useContext(QueryClientContext);
  return client && agentId ? (
    <ClassifiedNativeBadge agentId={agentId} orgId={orgId} options={options} />
  ) : null;
}
function ClassifiedNativeBadge({
  agentId,
  orgId,
  options,
}: {
  agentId: string;
  orgId: string | null;
  options?: AiAgentProfilesOptions;
}) {
  const isAi = useIsAiNativeAgent(orgId, options);
  return (
    <span className="inline-flex w-6 shrink-0 items-center align-middle">
      {isAi(agentId) === true ? <AiAgentStar /> : null}
    </span>
  );
}
